/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoModelsCustomWarning
 */
export interface DigitizingserviceMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function DigitizingserviceMelcoModelsCustomWarningFromJSON(json: any): DigitizingserviceMelcoModelsCustomWarning {
    return DigitizingserviceMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function DigitizingserviceMelcoModelsCustomWarningToJSON(value?: DigitizingserviceMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


